import React from 'react';
import { STYLES } from '../../constants/styles';
import { classNames } from '../../utils/classNames';

interface BaseInputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'password' | 'email' | 'url';
  required?: boolean;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
  helpText?: string;
  error?: boolean;
}

export const BaseInput: React.FC<BaseInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  required = false,
  disabled = false,
  className = '',
  icon,
  helpText,
  error = false
}) => {
  const inputClasses = classNames(
    STYLES.INPUTS.BASE,
    error && STYLES.INPUTS.ERROR,
    className
  );

  return (
    <div className="mb-4">
      {label && (
        <label className={STYLES.INPUTS.LABEL}>
          {icon && <span className="inline-block mr-1">{icon}</span>}
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={inputClasses}
      />
      {helpText && (
        <p className={STYLES.INPUTS.HELP_TEXT}>{helpText}</p>
      )}
    </div>
  );
};